import { Visibility, VisibilityOff } from '@mui/icons-material'
import { IconButton, InputAdornment, TextField } from '@mui/material'
import React from 'react'
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const ConfirmPassword = ({ confirmPassword, setConfirmPassword, disabled }) => {

    const {t} = useTranslation("register")

    const [showPassword, setShowPassword] = useState(false);
    const handleClickShowPassword = () => setShowPassword((show) => !show);

    return (
            <TextField
                required
                fullWidth
                name="confirmPassword"
                label={t("confirmPassword")}
                type={showPassword ? 'text' : 'password'}
                id="confirmPassword"
                autoComplete="current-password"
                size='small'
                value={confirmPassword}
                disabled={disabled}
                style={{backgroundColor: disabled && "#f2f2f2"}}
                onChange={(event) => {
                    setConfirmPassword(event.target.value);
                }}
                InputProps={{
                    endAdornment: (
                        <InputAdornment position="end">
                            <IconButton
                                onClick={handleClickShowPassword}
                                sx={{ p: 0 }}
                            >
                                {showPassword ? <VisibilityOff /> : <Visibility />}
                            </IconButton>
                        </InputAdornment>
                    ),
                }}
            />
    )
}

export default ConfirmPassword